import React, { useState } from "react"
import types from "prop-types"
import clsx from "clsx"
import { useSelector } from "react-redux"
import { users as getUsers } from "reduxSlices/formSubmissionSlice"
import { questionShape } from "utils/propTypeShapes"
import { XIcon } from "shared/icons"
import FormsyUserMultiSelect from "./FormsyUsersMultiSelectAnswerField"

const ENTER_KEY = "Enter"

const userOptions = (users) => users.map((user) => ({ label: `${user.fullName}${user.active ? "" : "(inactive)"}`, value: user.id, active: user.active }))

const optionRenderer = ({ item, methods }) => {
  const bgColor = item.active ? "bg-reactSelectItemDefault" : "bg-gray-700"
  const { dropDown, removeItem } = methods
  const handleKeyDownRemoveItem = (e) => {
    if (e.key === ENTER_KEY) {
      removeItem(null, item)
      e.preventDefault()
    }
  }
  const toggleDropdown = (e) => {
    if (e.key === ENTER_KEY) {
      dropDown("toggle")
      e.preventDefault()
    }
  }

  return (
    <div
      key={item.value}
      className="mx-0.5 w-full"
    >
      <div
        className={clsx("flex justify-between rounded py-0.5 px-2 mr-0.5 mt-0.5 text-white items-center hover:opacity-90", bgColor)}
      >
        <span
          className="react-dropdown-select-option-label rounded"
          tabIndex={0}
          onKeyDown={(e) => toggleDropdown(e)}
          role="button"
          aria-label="toggle dropdown"
        >
          {item.label}
        </span>

        {/*  if this is a button, selecting an option from the dropdown via keyboard will bubble
             and remove an existing selection. Using role for accessbility instead. */}
        <div
          className="p-1 cursor-pointer"
          onClick={() => removeItem(null, item)}
          onKeyDown={(e) => handleKeyDownRemoveItem(e)}
          aria-label={`remove ${item.label}`}
          role="button"
          tabIndex={0}
        >
          <XIcon
            className="h-6 w-6 text-white hover:text-red"
            ariaHidden
          />
        </div>
      </div>
    </div>
  )
}

const UsersMultiSelectAnswerField = ({
  question,
  initialValue = { user_ids: [] },
  disabled = false,
  className = "",
  hasBaseInputStyle = false,
  edit = false,
}) => {
  const { required, uuid } = question
  const users = useSelector(getUsers)
  const [showErrors, setShowErrors] = useState(false)

  let validations = null

  if (!edit) {
    validations = required ? { userArrayNotEmpty: true } : null
  }

  // Must pass value prop for Formsy to register the value
  // Pass values prop for the component to find the selected options
  return (
    <FormsyUserMultiSelect
      className={clsx("form-input", className)}
      label="select one or more users"
      searchable
      keepSelectedInList={false}
      disabled={disabled}
      hasBaseInputStyle={hasBaseInputStyle}
      name={uuid}
      optionRenderer={optionRenderer}
      options={userOptions(users)}
      placeholder="Select one or more users"
      showErrors={showErrors}
      setShowErrors={setShowErrors}
      value={initialValue}
      values={initialValue.user_ids}
      validations={validations}
    />
  )
}

UsersMultiSelectAnswerField.propTypes = {
  question: questionShape.isRequired,
  initialValue: types.object,
  disabled: types.bool,
  className: types.string,
  hasBaseInputStyle: types.bool,
  edit: types.bool,
}

export default UsersMultiSelectAnswerField
